<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/groupOrderInfo' }">订单管理</el-breadcrumb-item>
                    <el-breadcrumb-item>群组订单</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" class="demo-form-inline" label-width="120px" size="mini">
                    <el-form-item label="客户姓名"  v-if="isShowCustomerName">
                        <el-input v-model="orderInfo.condition.customerName" placeholder="客户姓名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="载体名称" v-if="isShowCarrierName">
                        <el-input v-model="orderInfo.condition.carrierName" placeholder="载体名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="样品编号" v-if="isShowSampleNum">
                        <el-input v-model="orderInfo.condition.sampleNum" placeholder="样品编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="实验编号" v-if="isShowExperimentNum">
                        <el-input v-model="orderInfo.condition.experimentNum" placeholder="实验编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否测序" v-if="isShowIsSequencing">
                        <el-select v-model="orderInfo.condition.isSequencing" filterable placeholder="请选择" clearable>
                            <el-option
                            v-for="item in yesOrNo"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <el-select v-model="orderInfo.condition.orderStatus" filterable placeholder="请选择" clearable>
                            <el-option
                            v-for="item in orderStatuses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="构建日期 从">
                        <el-date-picker type="date" placeholder="选择日期" v-model="orderInfo.condition.constructionDateStart" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="构建日期 到">
                            <el-date-picker type="date" placeholder="选择日期" v-model="orderInfo.condition.constructionDateEnd" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="支付意愿" v-if="isShowPayWillingness">
                        <el-select v-model="orderInfo.condition.payWillingness" filterable placeholder="请选择" clearable>
                            <el-option
                            v-for="item in payWillingnesses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="归属责任客户" v-if="isShowAttributableCustomer">
                        <el-input v-model="orderInfo.condition.attributableCustomer" placeholder="归属责任客户" clearable></el-input>
                    </el-form-item>
                    <el-row  type="flex" justify="end">
                        <el-form-item label="" >
                            <el-button type="info" @click="queryOrderInfo" size="mini">查询</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="orderInfos"
                    style="width: 100%"
                    v-if="tableHeight"
                    :height="tableHeight"
                    size="mini"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    :row-style="rowStyle">
                    <el-table-column prop="experimentNum" fixed label="实验编号" width="150"></el-table-column>
                    <el-table-column prop="orderCode" label="订单编号" width="150"></el-table-column>
                    <el-table-column prop="customerName" label="客户姓名" width="150"></el-table-column>
                    <el-table-column prop="carrierName" label="载体名称" show-overflow-tooltip width="160"></el-table-column>
                    <el-table-column prop="sampleNum" label="样品编号" width="100"></el-table-column>
                    <el-table-column prop="resistance" label="抗性" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="bacterialStrain" label="菌株" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="insertFragment" label="插入片段" width="200"></el-table-column>
                    <el-table-column prop="isPurifyingDesc" label="是否已经纯化" width="200"></el-table-column>
                    <el-table-column prop="upstreamSite" label="上游位点" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="downstreamSite" label="下游位点" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="isSequencingDesc" label="是否测序" width="200"></el-table-column>
                    <el-table-column prop="positiveCloneNum" label="阳性克隆数" width="200"></el-table-column>
                    <el-table-column prop="sequencePrimerName" label="测序引物名称" show-overflow-tooltip v-if="isShowSequencePrimerName" width="200"></el-table-column>
                    <el-table-column prop="email" label="测序邮箱" show-overflow-tooltip v-if="isShowEmail" width="200"></el-table-column>
                    <el-table-column prop="insertFragmentSeq" label="插入片段序列" show-overflow-tooltip v-if="isShowInsertFragmentSeq" width="200"></el-table-column>
                    <el-table-column prop="orderStatusDesc" label="订单状态" width="200"></el-table-column>
                    <el-table-column prop="companyKtr" label="加测引物碱基数" width="110"></el-table-column>
                    <el-table-column prop="companyJkr" label="测序反应数" width="100"></el-table-column>
                    <!-- <el-table-column prop="companySg" label="生工" width="100"></el-table-column> -->
                    <!-- <el-table-column prop="companyQk" label="擎科" width="100"></el-table-column>
                    <el-table-column prop="companyHc" label="合测" width="100"></el-table-column> -->
                    <el-table-column prop="resultFileName" label="测序结果" v-if="isShowResultFileName" width="200">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="dowloadFile(scope.row)">{{ scope.row.resultFileName  }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderAmount" label="订单金额" width="200"></el-table-column>
                    <el-table-column prop="payWillingnessDesc" label="支付意愿确认" width="200"></el-table-column>
                    <el-table-column prop="customSettlementAmount" label="客户结算金额" width="200"></el-table-column>
                    <el-table-column prop="agentSettlementAmount" label="代理结算金额" v-if="isShowAgentSettlementAmount" width="200"></el-table-column>
                    <el-table-column prop="attrCustomerName" label="归属责任客户" v-if="isAttributableCustomer" width="200"></el-table-column>
                    <el-table-column prop="agentName" label="代理/收送样员" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <span v-if="isHasAuthority">
                                <el-button @click="update(scope.row)" type="text" size="small">编辑</el-button>
                            </span>
                            <span style="margin-left:5px;">
                                <el-button @click="view(scope.row)" type="text" size="small">查看</el-button>
                            </span>
                            <span style="margin-left:5px;" v-if="isHasDel">
                                
                            </span>
                            <span v-if="isHasDel && scope.row.status === 'NORMAL'">
                                <el-button v-if="isHasDel" @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                            </span>
                            <span v-else-if="isHasDel && scope.row.status === 'DELETED'">
                                <el-button @click="handleReduction(scope.row)" type="text" size="small">还原</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!--  -->
        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="80%">
                <OrderInfoUpdate v-if="isUpdate" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoUpdate>
                <OrderInfoView v-if="isView" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoView>
        </el-drawer> 
    </div>
    
</template>

<script>
import GlobeConstant from '../../assets/js/GlobeConstant';
import OrderInfoUpdate from './OrderInfoUpdate.vue';
import OrderInfoView from './OrderInfoView.vue';

export default {
    name:'GroupOrderInfo',
    components: {
        OrderInfoUpdate,
        OrderInfoView,
    },
    data() {
        return {
            orderInfo:{
                condition:{
                },
                pageNum: 1,
                pageSize:20
            },
            drawer: false,
            direction: 'rtl',
            orderInfos: [],
            currentPage: 1,
            pageSize:20,
            total:10,
            timer:'',
            orderInfoProp:{},
            title:"新增订单",
            dataStatuses:[],
            isReceipts: [],
            dialogFormVisible: false,
            formLabelWidth:"120px",
            titleView: "查看订单",
            drawerView: false,
            isUpdate: true,
            isView: true,
            isHasAuthority: false,
            isHasAuthority1: false,
            isHasAuthority2: false,
            isShowCustomerName: false,
            isShowCarrierName: false,
            isShowSampleNum: false,
            isShowExperimentNum: false,
            isShowIsSequencing: false,
            isShowPayWillingness: false,
            isShowAttributableCustomer: false,
            isShowRegionalAgency: false,
            isShowOverallPlan: false,
            labelStyle:{"text-align":"right"},
            totalOrderAmount: "",
            totalCommissionAmount:"",
            isHasDel: false,
            confirmationReviews: [],
            isShowQuotationAmount: false,
            directors:[],
            commissioners:[],
            tableHeight: "",//表格高度
            confirmationReviewDisabled: false,
            isReceiptDisabled: false,
            isCommissionDisabled: false,
            isCommissions: [],
            orderStatuses:[],
            statusDisabled: true,
            loading: true,
            props: { multiple: true, checkStrictly: true},
            yesOrNo: [],
            payWillingnesses: [],
            isHasAddAuthority: false,
            isShowSequencePrimerName: true,
            isShowInsertFragmentSeq: true,
            isShowResultFileName: true,
            isAttributableCustomer: true,
            isShowAgentSettlementAmount: true,
            isShowEmail: true,
        }
    },
    methods: {
        update(row) {
            this.title = "修改订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = true;
            this.isView = false;
        },
        view(row) {
            this.title = "查看订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = false;
            this.isView = true;
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.queryOrderInfo();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryOrderInfo();
        },
        handleClose(done) {
            if(!this.isView) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryOrderInfo();
                })
                .catch(() => {});
            } else {
                done();
            }
        },
        handleCloseView(done) {
            this.$confirm('确认关闭？')
            .then(()=> {
                done();
                this.queryOrderInfo();
            })
            .catch(() => {});
        },
        queryOrderInfo() {
            this.loading = true;
            this.orderInfo.pageNum = this.currentPage;
            this.orderInfo.pageSize = this.pageSize;
            this.orderInfo.condition.isGroup = true;
            this.$axios.post("/order/find",this.orderInfo).then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderInfos = res.data.result.list;
                        this.total = res.data.result.total;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        createOrderInfo() {
            this.title = "新增订单";
            this.drawer = true;
            this.timer = new Date().getTime();
            this.orderInfoProp = {};
            this.isUpdate = true;
            this.isView = false;
        },
        closeDrawer() {
            this.drawer = false;
            this.queryOrderInfo();
        },
        rowStyle({ row }) {
            if(row.dataColor === 'GREEN') {
                let styleJson = {
                    "background-color": "lightgreen"
                }
                return styleJson;
            } else if(row.dataColor === 'RED') {
                let styleJson = {
                    "background-color" : "#F08080"
                }
                return styleJson;
            } else if(row.dataColor === 'YELLOW') {
                let styleJson = {
                    "background-color": "lightyellow"
                }
                return styleJson;
            } else if(row.dataColor === 'GRAY') {
                let styleJson = {
                    "background-color": "lightgray"
                }
                return styleJson;
            } else if(row.dataColor === 'BLUE') {
                let styleJson = {
                    "background-color": "lightblue"
                }
                return styleJson;
            } else if(row.dataColor === 'PURPLE') {
                let styleJson = {
                    "background-color": "#E8B1FF"
                }
                return styleJson;
            } else if(row.dataColor === 'ORANGE') {
                let styleJson = {
                    "background-color": "#FFA500"
                }
                return styleJson;
            }
            
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        } else if(dictType === 'ORDER_STATUS') {
                            this.orderStatuses = res.data.result;
                        } else if(dictType === 'PAY_WILLINGNESS') {
                            this.payWillingnesses = res.data.result;
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        handleDel(row) {
            this.$confirm('您确认删除此订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$axios.post("/orderInfo/delete",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.queryOrderInfo();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        getTableHeight() {
            let tableH = 400; //距离页面下方的高度
            let tableHeightDetil = window.innerHeight - tableH;
            if (tableHeightDetil <= 300) {
                this.tableHeight = 300;
            } else {
                this.tableHeight = window.innerHeight - tableH;
            }
        },
        handleReduction(row) {
            this.$confirm('您确认还原此订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$axios.post("/orderInfo/reduction",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message({
                                type: 'success',
                                message: '还原成功!'
                            });
                            this.queryOrderInfo();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消还原'
                });          
            });
        },
        exportOrder() {
            this.loading = true;
            this.orderInfo.pageNum = this.currentPage;
            this.orderInfo.pageSize = this.pageSize;
            this.$axios.post("/order/exportExcel",this.orderInfo,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('导出成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        dowloadFile(row) {
            var param = {
                id:row.orderId
            }
            this.$axios.post("/order/downloadFile",param,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('下载成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        }
    },
    mounted() {
        this.$bus.$on(GlobeConstant.orderinfoupdate_to_orderinfo_close, this.closeDrawer);
        this.user = JSON.parse(window.localStorage.getItem("user"));
        this.queryOrderInfo();
        if(this.user.roleCode === 'ADMIN' || this.user.roleCode === 'SUPER') {
            this.isHasAuthority = true;
            this.isAdmin = true;
            this.isShowCustomerName = true;
            this.isShowCarrierName = true;
            this.isShowSampleNum = true;
            this.isShowExperimentNum = true;
            this.isShowIsSequencing = true;
            this.isShowPayWillingness = true;
            this.isShowAttributableCustomer = true;
            this.isShowRegionalAgency = true;
            this.isShowOverallPlan = true;
        } else if(this.user.roleCode === 'AGENT') {
            this.isShowCustomerName = true;
            this.isShowSequencePrimerName = false;
            this.isShowInsertFragmentSeq = false;
            this.isShowResultFileName = false;
            this.isShowEmail = false;
        } else if(this.user.roleCode === 'RESPONSIBLE') {
            this.isShowCustomerName = true;
            this.isShowPayWillingness = true;
            this.isHasAddAuthority = true;
            this.isAttributableCustomer = false;
            this.isShowAgentSettlementAmount = false;
            this.isHasAuthority = true;
        } else if(this.user.roleCode === 'ORDINARY') {
            this.isShowPayWillingness = true;
            this.isHasAddAuthority = true;
            this.isShowAgentSettlementAmount = false;
            this.isShowEmail = false;
        }
        this.queryDicts("YES_NO");
        this.queryDicts("ORDER_STATUS");
        this.queryDicts("PAY_WILLINGNESS");
        let _this = this;
        window.onresize = () => {
        if (_this.resizeFlag) {
            clearTimeout(_this.resizeFlag);
        }
        _this.resizeFlag = setTimeout(() => {
            _this.getTableHeight();
            _this.resizeFlag = null;
        }, 100);
        };

    },
    beforeDestroy() {
        this.$bus.$off(GlobeConstant.orderinfoupdate_to_orderinfo_close);
    },
    created() {
        this.getTableHeight();
    }
    
}


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .margin-top {
        margin-top: 10px;
    }
    /* ::v-deep .el-table tbody tr:hover>td { 
        background-color: transparent !important;
    }
    ::v-deep .el-table__fixed-right tbody tr:hover>td {
        background-color: transparent !important;
    } */

    ::v-deep  .el-table .el-table__body tr.hover-row > td{
        background-color: #FFC0CB !important
    }

    ::v-deep  .el-tablle--enable-row-hover .el-table__body tr:hover > td{
        background-color:#FFC0CB !important
    }

    .emptyBg {
        display:block;
    }

</style>
